import { Controller } from "@hotwired/stimulus"

// Animates a sequential energy fill: ring 1 → connector → ring 2 → connector → …
// Rings use SVG stroke-dashoffset; connectors use CSS scaleX.
export default class extends Controller {
  static targets = ["ring", "connector"]

  declare ringTargets: SVGCircleElement[]
  declare connectorTargets: HTMLElement[]

  private timers: number[] = []

  private readonly CIRCUMFERENCE = 427   // 2π × r68
  private readonly RING_MS       = 1400  // time to fill one ring
  private readonly CONN_MS       = 600   // time to extend one connector
  private readonly HOLD_MS       = 2200  // pause before restart

  connect() {
    this.timers.push(window.setTimeout(() => this.runCycle(), 600))
  }

  disconnect() {
    this.timers.forEach(t => clearTimeout(t))
    this.timers = []
  }

  private reset() {
    this.ringTargets.forEach(r => {
      r.style.transition = "none"
      r.style.strokeDashoffset = String(this.CIRCUMFERENCE)
    })
    this.connectorTargets.forEach(c => {
      c.style.transition = "none"
      c.style.transform = "scaleX(0)"
    })
  }

  private runCycle() {
    this.reset()

    // One frame gap so the reset paint commits before transitions start
    let elapsed = 30

    this.ringTargets.forEach((ring, i) => {
      this.timers.push(window.setTimeout(() => {
        ring.style.transition = `stroke-dashoffset ${this.RING_MS}ms cubic-bezier(0.4, 0, 0.2, 1)`
        ring.style.strokeDashoffset = "0"
      }, elapsed))
      elapsed += this.RING_MS

      if (this.connectorTargets[i]) {
        this.timers.push(window.setTimeout(() => {
          const c = this.connectorTargets[i]
          c.style.transition = `transform ${this.CONN_MS}ms cubic-bezier(0.4, 0, 0.2, 1)`
          c.style.transform = "scaleX(1)"
        }, elapsed))
        elapsed += this.CONN_MS
      }
    })

    this.timers.push(window.setTimeout(() => this.runCycle(), elapsed + this.HOLD_MS))
  }
}
